import { applyUserTranslationsAllTypes } from "@/lib/utils";
import type { AdditionalLayer } from "@/types/models/capas";
import { capasRepository } from "../repositories/capas.repository";

export const capasService = {
  async fetchByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<AdditionalLayer[]> {
    const data = await capasRepository.fetchByTenant(params.tenantId);

    return applyUserTranslationsAllTypes(data ?? [], params.userLang, ["nombre"]);
  },

  create: capasRepository.create,

  update: capasRepository.update,

  delete: capasRepository.delete,
};